import { Form, useForm } from '@/components/forms';
import Input from '@/components/forms/Input';
import { Translation, useDynamicLocale } from '@/hoslog-intl';
import { z } from 'zod';
import useUpdateMainPageShuffle from '../hooks/useUpdateMainPageShuffle';

const setShuffleModalSchema = z.object({
  top5: z.string().min(1, { message: 'Required' }),
  remaining20: z.string().optional(),
  groupShuffle: z.string(),
});

export const SetShuffleForm = ({
  defaultValues,
  canUpdateShuffleTime,
}: {
  defaultValues?: {
    top5: string;
    remaining20: string;
    groupShuffle: string;
  };
  canUpdateShuffleTime: boolean;
}) => {
  const form = useForm({ schema: setShuffleModalSchema, mode: 'onBlur', defaultValues });
  const { t } = useDynamicLocale();
  const { mutateAsync } = useUpdateMainPageShuffle();
  return (
    <Form
      form={form}
      onSubmit={async (data) => {
        const payload = {
          setShuffleTime1: Number(data.top5),
          setShuffleTime2: Number(data.remaining20),
          groupShuffle: Number(data.groupShuffle),
        };
        await mutateAsync(payload);
      }}
    >
      <div className="space-y-[18px]">
        <div className="grid grid-cols-2 gap-4.5">
          <Input
            label="common.form.label.top5"
            {...form.register('top5')}
            placeholder={t('common.form.placeholder.tenMins')}
            isRequired={false}
            disabled={!canUpdateShuffleTime}
            onlyNumbers
          />
          <Input
            label="common.form.label.remaining20"
            {...form.register('remaining20')}
            placeholder={t('common.form.placeholder.tenMins')}
            isRequired={false}
            disabled={!canUpdateShuffleTime}
            onlyNumbers
          />
        </div>
        <div className="flex items-center gap-2">
          <div className="text-foreground text-control font-bold leading-5">
            <Translation id="common.page.modal.groupShuffling" />
          </div>
          <div className="h-px flex-1 bg-border-divider"></div>
        </div>
        <Input
          label="common.form.label.shufflingTime"
          {...form.register('groupShuffle')}
          placeholder={t('common.form.placeholder.tenMins')}
          isRequired={false}
          disabled={!canUpdateShuffleTime}
          onlyNumbers
        />
      </div>
    </Form>
  );
};
